import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

export default {
  state: {
    maintenanceList: [],
  },
  getters: {
    getAllMaintenance: (state) => state.maintenanceList,
  },
  actions: {
    getMaintenanceHistory({ commit }, payload) {
      const response = makeApiCall(
        `maintenanceTasks/getMaintenanceHistory`,
        "POST",
        payload
      );
      return response;
    },
    async getAllMaintenance({ commit }, payload) {
      const response = await makeApiCall(
        `maintenanceTasks/getAll`,
        "POST",
        payload
      );
      if (!response.error) {
        commit("setMaintenanceList", response.data.data);
      }
      return response;
    },
    async saveMaintenance({ commit }, payload) {
      const response = await makeApiCallWithImages(
        `maintenanceTasks/save`,
        "POST",
        payload
      );
      return response;
    },
    async deleteMaintenance({ commit }, payload) {
      const response = await makeApiCall(
        `maintenanceTasks/delete`,
        "DELETE",
        payload
      );
      return response;
    },
    async getMaintenanceById({ commit }, payload) {
      const response = await makeApiCall(
        `maintenanceTasks/get?id=${payload}`,
        "GET",
        payload
      );
      return response;
    },
  },
  mutations: {
    setMaintenanceList(state, payload) {
      state.maintenanceList = payload;
    },
  },
};
